import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../../constants/fetchStatuses';
import { ReducerState } from '../../../store.types';

export const employeeStatusesSelector = ({ employeeStatuses }: ReducerState) => employeeStatuses;

export const employeeStatusesLoadingSelector = createSelector(
  employeeStatusesSelector,
  ({ fetchEmployeeStatusesStatus }) => fetchEmployeeStatusesStatus === fetchStatuses.pending,
);

export const employeeMaritalStatusesLoadingSelector = createSelector(
  employeeStatusesSelector,
  ({ fetchEmployeeMaritalStatusesStatus }) => fetchEmployeeMaritalStatusesStatus === fetchStatuses.pending,
);
